import * as $ from 'jquery';
import * as _ from 'underscore';

import { IGlob } from '../../../pdc-platform/src/ts/Glob';
import { apiCall } from './AqlUtility';
import { config } from '../../../pdc-platform/src/ts/config';
import { store as RMStore } from '../../../pdc-widget-resource-manager/src/ts/flux/glob';
import { ITreeNode } from '../../../pdc-platform/src/ts/Interfaces';

const saveAs = require('file-saver');
const JSZip = require('jszip');

export interface IDiscriptionTreeNode extends ITreeNode {
    descriptionID: string;
}

export interface IExportStore {
    get descriptionID(): string;
    createExportData(values: string[]): any;
    getItemsToExport?(): Promise<ITreeNode[]>;
    getBranchContent?(parentID: string): Promise<IDiscriptionTreeNode[]>;
}

export interface IExportImportDescription {
    ComponentExport?: any;
    componentOptionsExport?: { [id: string]: any };
    ComponentImport?: any;
    componentOptionsImport?: { [id: string]: any };

    exportStore?: IExportStore;

    id: string;
    title?: string;
    subtitle?: string;
    subNodes?: IDiscriptionTreeNode[];
    description?: string;
    export: (options: any) => any;
    import: (options: any) => string[];
}

export interface IExportImportObjectValue {
    expanded?: boolean;
    data?: any;
    selectedItems?: any[];
}

export interface IExportImportObject {
    [id: string]: IExportImportObjectValue;
}

export interface IExportImportDescriptionCollection {
    [id: string]: IExportImportDescription;
}

const _descriptions: IExportImportDescriptionCollection = {};

export function register(description: IExportImportDescription) {
    if (_descriptions[description.id] != null) {
        throw new Error('Export/Import description with id ' + description.id + ' is already available.');
    }

    _descriptions[description.id] = description;
}

export function getDescriptionsArray() {
    return _.values(_descriptions);
}

export function getDescriptions() {
    return $.extend(true, {}, _descriptions);
}

export function getDescription(id: string) {
    return _descriptions[id];
}

export function doImport(importOptionsObj: any, importObj: IExportImportObject, override: boolean, glob: IGlob) {
    let keys = _.keys(importOptionsObj);
    let defFinish = $.Deferred(); // for doImportInternal()

    if (keys.length == 0) {
        defFinish.resolve(false);
        return defFinish;
    }

    let listResFiles = null; // input Resources files
    let keyListRes = null; // Resources list

    //first of all: check for missed items and errors in each of ImportComponent:
    let errorList = [];

    _.each(keys, (key) => {
        const options = importOptionsObj[key];
        const desc = _descriptions[key];

        if (desc != null) {
            errorList = errorList.concat(desc.import(options));
        }
        if (key === 'resources') {
            listResFiles = options.listResFiles;
            keyListRes = options.keyList;
        }
    });

    errorList = _.compact(errorList);

    // if some errors presented - go out:
    if (errorList.length > 0) {
        errorList.unshift('Import is skipped: \n');

        _.each(errorList, (item) => {
            glob.AppActions.showNotification_Fail(item);
        });

        defFinish.resolve(false);

        return defFinish;
    }

    // make import of Resources at first:
    if (listResFiles != null && keyListRes != null) {
        JSZip.loadAsync(importOptionsObj.resources.zipFile) // 1) read the Blob
            .then(
                (zip) => {
                    $.when
                        .apply(
                            $,
                            keyListRes.map((item) => {
                                let def: JQueryDeferred<any> = $.Deferred();

                                zip.file(item.inputFile)
                                    .async('arraybuffer')
                                    .then((content) => {
                                        const blob = new Blob([content], { type: item.data.MimeType });
                                        RMStore.postUploadOne(blob, item.data.GUID, def);
                                    });
                                return def;
                            })
                        )
                        .done(function () {
                            listResFiles = null; // VR: must delete this API File ref.

                            doImportInternal(); //do it ONLY after Resources are loaded to backend:
                        });
                },
                (e) => {
                    glob.AppActions.showNotification_Fail(
                        'Error reading ' + importOptionsObj.resourcse.zipFile.name + ': ' + e.message,
                        null,
                        {
                            manualDestroy: true
                        }
                    );
                }
            );
    } else {
        doImportInternal(); // do it now:
    }

    // Main DoImport function:
    function doImportInternal() {
        apiCall(glob.AppActions, 'import', {
            data: importObj,
            override: override,
            useImportWSGUID: importOptionsObj.workspaces?.useImportWSGUID === true,
            importList: importOptionsObj
        })
            .done(function (...args) {
                const importRes: any = _.compact(args);

                let errorArray: string[] = [];
                let isSuccess = true;

                _.each(importRes, function (jsonrpc: any) {
                    if (jsonrpc != undefined && jsonrpc.result != undefined) {
                        if (jsonrpc.result.results != null && jsonrpc.result.success != null) {
                            errorArray = jsonrpc.result.results.split('\n');
                            isSuccess = jsonrpc.result.success;
                        } else {
                            errorArray = jsonrpc.result.split('\n');
                        }
                    }
                });

                errorArray = _.map(errorArray, (item) => {
                    return item + '\n';
                });

                const updatedWsList = _.chain(errorArray)
                    .map((item) => {
                        const wsmatch = item.match(/^\s*Workspace#(\d+)/);

                        if (wsmatch != null && wsmatch.length === 2) {
                            return parseInt(wsmatch[1]);
                        }
                    })
                    .filter((wsid) => {
                        return wsid != null;
                    })
                    .value();

                _.each(updatedWsList, (wsid) => {
                    glob.AppActions.workspaceViewLoadContent(wsid, true, null, true);
                    glob.AppActions.workspaceReset(wsid);
                });

                //VR: now we need store all settings after Import done. So, rem this: glob.AppActions.dirsCleanCache();

                if (errorArray.length > 0) {
                    if (isSuccess) {
                        glob.AppActions.showNotification_Success('Import has been completed successfully', null, {
                            details: errorArray
                        });
                    } else {
                        glob.AppActions.showNotification_Warning('Import completed with some warnings', null, {
                            details: errorArray,
                            manualDestroy: true
                        });
                    }
                } else {
                    glob.AppActions.showNotification_Success('Import has been completed successfully');
                }
            })
            .always(() => {
                defFinish.resolve(true); // to drop a ProgressBar in parent Module
            });
    }

    return defFinish;
}

export function doExport(exportObj: IExportImportObject, glob: IGlob) {
    const sectionList = [];

    let selectedSections = '';

    _.each(exportObj, (options, key) => {
        const description = _descriptions[key];

        if (description != null) {
            const data = description.export(options.data);

            if (data != null) {
                sectionList.push(data);
                selectedSections += selectedSections.length === 0 ? key : '-' + key;
            }
        }
    });

    const defFinish = $.Deferred();

    if (selectedSections.length === 0) {
        defFinish.resolve();
        return defFinish;
    }

    // get .JSON file at the first:
    apiCall(glob.AppActions, 'export', {
        sectionList: sectionList
    })
        .then((obj: any) => {
            try {
                obj.result = JSON.parse(obj.result);
            } catch (e) {
                //obj.result = obj.result;
            }

            return obj.result;
        })
        .done(function (...args) {
            // now save the .JSON file to disk:
            const exportRes = args[0]; //VR: only one object passed to this f.
            // Create the Name of Export File:
            const now = new Date();
            const timeKey = now.valueOf();
            const exportFilename = `export-${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}-${selectedSections}-${timeKey}`;

            // VR: start Resources files download routine:
            if (exportRes.resources != null) {
                const apiEndpoint = config.getAPIEndpoint();
                const path = ['Resources'];
                const url_start = apiEndpoint + '/' + path.join('/') + '/';
                const zip = new JSZip();
                const skippedResources = [];

                console.log('Exporting ', exportRes.resources.length, ' resources');

                Promise.all(
                    exportRes.resources.map((res) => {
                        const filenameRes = res.data.GUID + '.DAT';
                        const url = url_start + (res.data.resid || 'undef');
                        const token = glob.AuthStore.getUserToken();
                        const httpHeaders = {};

                        if (token != null) {
                            httpHeaders['Authorization'] = 'Bearer ' + token;
                        }

                        return fetch(url, { method: 'GET', headers: httpHeaders })
                            .then(async (response) => {
                                if (!response.ok) {
                                    let errorInfo;

                                    try {
                                        // Try to get error details from response body
                                        errorInfo = await response.json();
                                    } catch (e) {
                                        // Fallback if response isn't JSON
                                        errorInfo = response.statusText;
                                    }

                                    const error = new Error(`HTTP ${response.status} ${JSON.stringify(errorInfo)}`);

                                    throw error;
                                } else {
                                    return response.blob();
                                }
                            })
                            .then((result) => {
                                console.log('Resource ', filenameRes, ' added to ZIP archive');
                                zip.file(filenameRes, result);
                            })
                            .catch((err) => {
                                const guid_with_error = res.data.GUID + ' ' + err.toString();

                                skippedResources.push(guid_with_error);
                                console.error('Failed to get resource: ' + guid_with_error);
                            });
                    })
                ).then(() => {
                    zip.generateAsync({
                        type: 'blob'
                    }).then((Data) => {
                        saveAs.saveAs(Data, exportFilename + '-resdata.zip');

                        if (skippedResources.length > 0) {
                            glob.AppActions.showNotification_Warning(
                                'The following resources were failed to fetch: ' + skippedResources.join(';\n '),
                                null,
                                { manualDestroy: true }
                            );
                        }

                        defFinish.resolve();
                    });
                });
            } else {
                defFinish.resolve();
            }

            // Save main .JSON file
            const exportFilenameExt = exportFilename + '.json';

            saveAs['saveAs'](new Blob([JSON.stringify(exportRes, null, 4)]), exportFilenameExt);
        });

    return defFinish;
}

export function createNodeID(descriptionID: string, type: string, id: string) {
    return descriptionID + '-' + type + '-' + id;
}

export function parseNodeID(value: string) {
    const parts = value.split('-');

    return { descriptionID: parts[0], type: parts[1], id: parts[2] };
}

export const DESCRIPTION_TYPE = 'desc';
